import React, { useEffect, useState } from 'react';
import { Card, Container, Label, Row } from 'reactstrap';
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from 'store';
import Form from './FormRender';
import { formGetRequest, getMataData } from 'store/customform/action';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import { handleSelectValue, isJson } from 'utils';
import { tenantGetOpenRequest } from 'store/user/action';
import Logo from 'Components/Common/Logo/Logo';
import HtmlBlock from 'Components/Common/HtmlBlock';
import FormBuilder from 'Components/Common/FormBuilder/FormBuilder';
import { studentGetRequest } from 'store/student/action';
import dataFields from '../Fields';

const FormRender = () => { 
	document.title = "Student Registration - Forms";
    const { tenantId , id } = useParams()
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const mode = searchParams.get("mode");
    const studentId = searchParams.get("id");
    const dispatch: ThunkDispatch<any, null, Action<string>> = useDispatch(); 
    const formDetails = useSelector((state: ApplicationState) => state.customform.customformDetails);
    const metadata = useSelector((state: ApplicationState) => state.customform.metadata);
    const tenatDetails = useSelector((state: ApplicationState) => state.user.tenatDetails);
    const studentDetails = useSelector((state: ApplicationState) => state.student.details);
    const [formData, setFormData] = useState<any>({})    
    const [defaultValues, setDefaultValues] = useState<any>({})    
    const [title, setTile] = useState<any>("")
    const [description, setDescription] = useState<any>({})
    const [col, setColumn] = useState({})   
    const [tenant, setTenant] = useState<any>({})
    const [student, setStudent] = useState<any>({})
    const [innitFormData, setInnitFormData] = useState<any>({})

    useEffect(() => {
        dispatch(getMataData(tenantId))
        dispatch(formGetRequest(tenantId,id))
        dispatch(tenantGetOpenRequest(tenantId))
        setStudent({label: '', value: studentId})
      }, [])


    useEffect(() => {
        let tenant = tenatDetails?.settings && isJson(tenatDetails?.settings) ? JSON.parse(tenatDetails?.settings) : tenatDetails?.settings;
        setTenant(tenant) 
    }, [tenatDetails])

    useEffect(() => {
        let data = studentDetails;
        if (data?.valuesJson) {
                    let info = data?.valuesJson && isJson(data?.valuesJson) ? JSON.parse(data?.valuesJson) : { ...data?.valuesJson };
                    // setFormValues(values);
                    let newData: any = {};
                    metadata && metadata.length && metadata.map((field: any, key: any) => {
                        let item = field?.valuesJson && isJson(field?.valuesJson) ? JSON.parse(field?.valuesJson) : field?.valuesJson
                        console.log("item", item)
                        let rendervalue = info?.[item.key]; 
                        if (item?.mergeColumns?.columns) {
                            let value = item?.mergeColumns?.columns
                            let values = value.split(",")
                            let newValue = "";
                            values?.length && values.map((item: any) => {
                                newValue = info?.[item] ? `${newValue ? newValue : ""} ${info?.[item]}${item.mergeColumns?.separator || " "}` : ""
                            })
                            rendervalue = newValue;
                        }                     
                        if (item.optionLabel) {
                            rendervalue = info?.[item.key]?.[item.optionLabel] ? {label: info?.[item.key]?.[item.optionLabel], value: info?.[item.key]?.["id"]} : null
                        }                     
                        else if (item.isMulti || item.type == "selectboxes") {
                            rendervalue = info?.[item.key];
                        }         
                        else if (item.type == 'select' || item.type == 'radio' || item.type == 'checboxes') {
                            rendervalue = handleSelectValue(info?.[item.key], item.values);
                        }         
                        else if (item.type == 'file') {
                            rendervalue = typeof info?.[item.key] !== 'object' ? info?.[item.key] : ''; 
                        }
                        newData[item.key]= rendervalue;
                    })
                    setDefaultValues({...defaultValues, ...studentDetails, ...newData}) 
                }
    }, [studentDetails])

      useEffect(() => {
        let fields: any = [];
        let newFormData = formDetails && formDetails.valuesJson && isJson(formDetails.valuesJson) ? JSON.parse(formDetails.valuesJson) : {}
         newFormData && newFormData?.components && newFormData?.components.length && newFormData.components.map((component: any)=> {
            metadata && metadata.length && metadata.map((field: any) => {                         
                let item = field.valuesJson && isJson(field.valuesJson) ? JSON.parse(field.valuesJson) : {}
                let newField = {...item, id: field.id}                
                if(component.id == field.id) 
                {
                    fields.push({...newField,  ...component.extras})
                }
            })
        })  
        setInnitFormData(newFormData)
        setFormData(fields)
        setColumn(newFormData.column)
        setDefaultValues(newFormData.values)
        setTile(newFormData.title)
        setDescription(newFormData.description)
      }, [formDetails, metadata])

      useEffect(() => {
        if(student) {
            dispatch(studentGetRequest(student?.value))
        }
      }, [student])


    const onSelect = (option: any) => {
        if(option) {
            setStudent(option)
            const newParams = new URLSearchParams(searchParams.toString());
            newParams.set("id", option.value); // Add or update id param
            navigate(`?${newParams.toString()}`, { replace: true });
        }
        else {
            setStudent(null)
            setDefaultValues(innitFormData.values)
            const newParams = new URLSearchParams(searchParams.toString());
            newParams.delete("id");
            navigate(`?${newParams.toString()}`, { replace: true });
        }
    }

    return (
        <React.Fragment>
            <ToastContainer />
            <Container>  
                <Logo tenant={tenant} />
                <Row>
                    <div className={'hstack justify-content-center fw-bold fs-20 text-decoration-underline text-center'}>
                        <Label>{title}</Label>
                    </div>
                </Row>
                <Card className='p-2'>
                    {
                        mode === 'edit' ? 
                            <div className='w-100 hstack justify-content-center'>
                                <div className='w-50'>
                                    <FormBuilder
                                        placeholder={'Select Student'}
                                        name={'student'}
                                        onChange={(e: any) => onSelect(e)}
                                        options={[]}
                                        label={'Student'}
                                        type={'datasetselect'}
                                        value={student}
                                        isEditState={true}
                                        actionButtons={false}
                                        defaultValue={student}
                                        Editable={true}
                                        rest={{model: 'students', optionLabel: 'name'}}
                                        invalid={true}
                                        resetValue={student}
                                    />
                                </div>
                            </div>
                        :  null
                    }
                    {description?.body && (
                        <Row className="m-3 border border-dark p-3 border-opacity-10">
                            <HtmlBlock html={description.body} />
                        </Row>
                    )}
                    <Form tenantId={tenantId} dataFields={formData || []} md={col} lg={col} xl={col} BtnClassName={"w-auto justify-content-end"}  btn_text={student?.value ? 'Update': 'Submit'} data={defaultValues} formId={id} studentId={student?.value} />
                </Card>
            </Container>
        </React.Fragment>
    );
}

export default FormRender;